<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-1 border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div
      class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between"
    >
      <!-- [ngClass]="isShowGrap ? 'sm:flex-col' : ''" -->
      <div>
        <div class="flex items-center gap-1">
          <div
            hoverMenu
            hoverDelay="50"
            #hoverDirective="hoverMenu"
            [matMenuTriggerFor]="infoMenu"
          >
            <button mat-icon-button color="primary">
              <mat-icon
                svgIcon="heroicons_outline:exclamation-circle"
              ></mat-icon>
            </button>
          </div>
          <mat-menu
            [hasBackdrop]="false"
            [overlapTrigger]="false"
            class="w-full"
            #infoMenu="matMenu"
          >
            <div class="p-4">
              <p>
                Reparte el inventario libre donde más se necesita. Aplica reglas
                y recomendaciones de IA para evitar faltantes o exceso en
                plantas, almacenes y rutas. Úsalo antes de picos de demanda o
                reabastecimientos.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Distribución de Inventario
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Distribuye el inventario libre para venta en base a la cantidad de
          <b>materiales</b> solicitados en los procesos de <b>pedido</b> y
          <b>cambio de productos</b>.
        </div>
      </div>
      <!-- Botones (derecha, posición fija) -->
      <div
        class="mt-6 flex shrink-0 items-center justify-center space-x-3 sm:ml-auto sm:mt-0"
      >
        <div class="flex flex-row justify-between items-center">
          <ng-container *ngIf="hasAdditionalData">
            <!-- Ver por -->
            <button
              mat-stroked-button
              color="primary"
              matTooltip="Ver por"
              class="mr-6"
              [matMenuTriggerFor]="actionMenuFilterScreen1_2"
              (menuOpened)="isViewMenuOpenScreen1_2 = true"
              (menuClosed)="isViewMenuOpenScreen1_2 = false"
            >
              <div class="flex items-center">
                <div class="pr-2">
                  <mat-icon svgIcon="heroicons_solid:eye"></mat-icon>
                </div>
                <div
                  class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px]"
                >
                  <span>Ver</span>
                  <small class="font-bold">{{ filterSelectScreen1_2 }}</small>
                </div>
                <mat-icon
                  [svgIcon]="
                    isViewMenuOpen ? 'arrow_drop_up' : 'arrow_drop_down'
                  "
                ></mat-icon>
              </div>
            </button>
          </ng-container>

          <mat-menu #actionMenuFilterScreen1_2="matMenu">
            <button
              color="primary"
              mat-menu-item
              (click)="handleViewScreen1_2(1)"
            >
              <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
              Todo
            </button>
            <button
              color="primary"
              mat-menu-item
              (click)="handleViewScreen1_2(2)"
            >
              <mat-icon svgIcon="heroicons_outline:document-check"></mat-icon>
              Cubierto
            </button>

            <button
              color="primary"
              mat-menu-item
              (click)="handleViewScreen1_2(3)"
            >
              <mat-icon svgIcon="heroicons_outline:clock"></mat-icon>
              No cubierto
            </button>
          </mat-menu>

          <ng-container *ngIf="selectedTabIndex === 1">
            <!-- Ver por -->
            <button
              mat-stroked-button
              color="primary"
              matTooltip="Ver por"
              class="mr-6"
              [matMenuTriggerFor]="actionMenuFilter"
              (menuOpened)="isViewMenuOpen = true"
              (menuClosed)="isViewMenuOpen = false"
            >
              <div class="flex items-center">
                <div class="pr-2">
                  <mat-icon svgIcon="heroicons_solid:eye"></mat-icon>
                </div>
                <div
                  class="flex flex-col p-2 content-center text-center gap-[3px] min-w-[60px]"
                >
                  <span>Ver</span>
                  <small class="font-bold"
                    >{{ filterSelectDistribution }}
                  </small>
                </div>
                <mat-icon
                  [svgIcon]="
                    isViewMenuOpen ? 'arrow_drop_up' : 'arrow_drop_down'
                  "
                ></mat-icon>
              </div>
            </button>
          </ng-container>

          <mat-menu #actionMenuFilter="matMenu">
            <button
              color="primary"
              mat-menu-item
              (click)="handleViewDistribution(1)"
            >
              <mat-icon svgIcon="heroicons_outline:eye"></mat-icon>
              Todos
            </button>
            <button
              color="primary"
              mat-menu-item
              (click)="handleViewDistribution(2)"
            >
              <mat-icon svgIcon="heroicons_outline:document-check"></mat-icon>
              Cumplido
            </button>

            <button
              color="primary"
              mat-menu-item
              (click)="handleViewDistribution(3)"
            >
              <mat-icon svgIcon="heroicons_outline:clock"></mat-icon>
              No Cumplido
            </button>
          </mat-menu>
        </div>

        <mat-icon
          [matTooltip]="
            isShowGrap ? 'Ocultar estadísticas' : 'Mostrar estadísticas'
          "
          (click)="onHandleGraph()"
          svgIcon="heroicons_solid:chart-bar"
          color="primary"
        ></mat-icon>

      <!-- Botón Reiniciar: solo en Step 2 -->
      <ng-container *ngIf="currentStep === 2">
        <button
          mat-icon-button
          color="primary"
          matTooltip="Reiniciar"
          *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE"
          (click)="openDialogAlertRestart()"
        >
          <mat-icon>restart_alt</mat-icon>
        </button>
      </ng-container>

      <!-- Botón de acción dinámico -->
      <button
        *canPermissionsOnly="[PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.IMPORT, PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE, PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.EXPORT]"
        mat-icon-button color="primary" [matTooltip]="getActionTooltip()" (click)="handleDynamicAction()"
      >
        <!-- Paso 0: SVG personalizado -->
        <ng-container *ngIf="currentStep === 0">
          <mat-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256">
              <g fill="#4f46e5" fill-rule="nonzero">
                <g transform="scale(5.12,5.12)">
                  <path
                    d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                  </path>
                </g>
              </g>
            </svg>
          </mat-icon>
        </ng-container>
      
        <!-- Paso 1 y 2: Material Icons -->
        <mat-icon *ngIf="currentStep === 1">{{ getActionIcon() }}</mat-icon>
          <!-- Paso 2: Procesar o Exportar según hasProcessed -->
          <mat-icon *ngIf="currentStep === 2">
            {{ hasProcessed ? 'file_download' : 'save' }}
          </mat-icon>
      </button>


        <button
          mat-icon-button
          [matMenuTriggerFor]="
            !isTabDisable.tab1
              ? actionMenu
              : !isTabDisable.tab2
                ? actionMenuTab2
                : actionMenuTab3
          "
          matTooltip="Acciones"
        >
          <mat-icon>more_vert</mat-icon>
        </button>

        <!--  Nav acciones Importar tab 1  -->
        <mat-menu #actionMenu="matMenu">
          <input
             #hiddenfileinput
            style="display: none"
            type="file"
            (change)="handleFileInput($event)"
            accept=".xlsx"
          />
          <button *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.EXPORT" mat-menu-item (click)="downloadTemplate()">
            <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
            Descargar Plantilla
          </button>
          <button
            [disabled]="
              !(PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.IMPORT | hasPermission) ||
              dataSource?.data?.length <= 0 || dataSourceNew?.data?.length > 0
            "
            mat-menu-item
            (click)="hiddenfileinput.click()"
          >
            <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
            Importar
          </button>
          <button
            [disabled]="!(PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.IMPORT | hasPermission) || dataSourceNew?.data?.length <= 0"
            mat-menu-item
            (click)="hiddenfileinput.click()"
          >
            <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
            Limpiar volver a Importar
          </button>
          <button
            [disabled]="!(PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE | hasPermission) || dataSourceNew?.data?.length <= 0"
            mat-menu-item
            (click)="handleNext(); closeMenu()"
          >
            <mat-icon svgIcon="heroicons_outline:play"></mat-icon>
            Continuar
          </button>
        </mat-menu>

        <!--  Nav acciones Importar tab 2  -->
        <mat-menu #actionMenuTab2="matMenu">
          <button *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE" mat-menu-item (click)="openDialogSave(true); closeMenu()">
            <mat-icon svgIcon="heroicons_outline:play"></mat-icon>
            Procesar y continuar
          </button>
          <button *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE" (click)="openDialogSave(false)" mat-menu-item>
            <mat-icon fontSet="material-icons-outlined">save</mat-icon>
            Guardar
          </button>
          <button *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE" mat-menu-item (click)="openDialogAlertRestart(); closeMenu()">
            <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
            Reiniciar
          </button>
        </mat-menu>

        <!--  Nav acciones Importar tab 3  -->
        <mat-menu #actionMenuTab3="matMenu">
          <button *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.EXPORT" mat-menu-item (click)="handleExportAll(); closeMenu()">
            <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
            Exportar Todo
          </button>
          <button *canPermissionsOnly="PERMISSIONS_ASSISTANT_DISTRIBUTION_STOCK.CREATE" mat-menu-item (click)="openDialogAlertRestart(); closeMenu()">
            <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
            Reiniciar
          </button>
        </mat-menu>
      </div>
    </div>
    <!-- <div class="relative flex flex-0 flex-col py-1 sm:flex-row sm:items-center sm:justify-between"> -->
    <!--
    
      <ng-container *ngIf="isShowGrap">
        <mat-icon
          matTooltip="
            Buscar
          "
          (click)="onHandleGraph()"
          svgIcon="heroicons_solid:magnifying-glass"
          color="primary"
          class="px-6"
        >
        </mat-icon>
      </ng-container>
   -->

    <!-- Cards Progress  screen 1.1 -->
    <ng-container *ngIf="isShowGrap">
      <div class="flex flex-col items-center justify-center w-full mt-4">
        <!-- Contenedor de tarjetas (centrado) -->
        <div
          class="flex flex-wrap items-center justify-center gap-4 px-2 w-full"
        >
          <!-- Card Progress Productos Cargados -->

          <div class="flex items-center">
            <div class="bg-blue-100 px-3 py-2 rounded">
              <mat-icon
                class="text-blue-500"
                svgIcon="heroicons_solid:archive-box-arrow-down"
              ></mat-icon>
            </div>
            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Productos Cargados</p>
              <p class="text-2xl font-semibold">
                {{ materialsInProcess.value }}
              </p>

              <mat-progress-bar
                mode="determinate"
                value="{{ materialsInProcess.load }}"
                [ngClass]="{
                  'progress-yellow': materialsInProcess.load < 100,
                  'progress-green': materialsInProcess.load === 100,
                }"
              ></mat-progress-bar>
            </div>
          </div>

          <!-- Card Progress Pedidos sin fecha de carga -->

          <div
            class="flex items-center cursor-pointer"
            (click)="openDialogInfo(0)"
          >
            <div class="bg-red-100 px-3 py-2 rounded">
              <mat-icon
                class="text-red-500"
                svgIcon="heroicons_solid:calendar"
              ></mat-icon>
            </div>
            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Pedidos en espera de carga</p>
              <p class="text-2xl font-semibold">
                {{ noSelectedOrders.value }}
              </p>

              <mat-progress-bar
                mode="determinate"
                value="{{ noSelectedOrders.load }}"
                [ngClass]="{
                  'progress-yellow': noSelectedOrders.load < 100,
                  'progress-red': noSelectedOrders.load === 100,
                }"
              ></mat-progress-bar>
            </div>
          </div>

          <div
            class="flex items-center cursor-pointer"
            (click)="openDialogInfo(1)"
          >
            <div class="bg-amber-100 px-3 py-2 rounded">
              <mat-icon
                class="text-amber-500"
                svgIcon="heroicons_solid:cog-6-tooth"
              ></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Pedidos en Proceso</p>
              <p class="text-2xl font-semibold">{{ selectedOrders.value }}</p>

              <mat-progress-bar
                mode="determinate"
                value="{{ selectedOrders.load }}"
                [ngClass]="{
                  'progress-yellow': selectedOrders.load < 100,
                  'progress-green': selectedOrders.load === 100,
                }"
              ></mat-progress-bar>
            </div>
          </div>

          <!-- Card  Cliente en Proceso -->
          <div
            class="flex items-center cursor-pointer"
            (click)="openDialogInfo(2)"
          >
            <div class="bg-violet-100 px-3 py-2 rounded">
              <mat-icon
                class="text-violet-500"
                svgIcon="heroicons_solid:user-group"
              ></mat-icon>
            </div>

            <div class="ml-4 w-full">
              <p class="text-gray-600 text-sm">Cliente en Proceso</p>
              <p class="text-2xl font-semibold">
                {{ selectedCustomers.value }}
              </p>

              <mat-progress-bar
                mode="determinate"
                class="w-full"
                value="{{ selectedCustomers.load }}"
                [ngClass]="{
                  'progress-yellow': selectedCustomers.load < 100,
                  'progress-green': selectedCustomers.load === 100,
                  'text-gray-400': selectedCustomers.load === 0,
                }"
              ></mat-progress-bar>
            </div>
          </div>

          <!-- Card Progress Entregados en Proceso -->
          <div class="p-4 flex items-center">
            <div class="bg-slate-100 px-3 py-2 rounded">
              <mat-icon
                class="text-slate-500"
                svgIcon="heroicons_solid:truck"
              ></mat-icon>
            </div>

            <div class="ml-4">
              <p class="text-gray-600 text-sm">Puntos de Entrega en Proceso</p>
              <p class="text-2xl font-semibold">{{ selectedAddress.value }}</p>

              <mat-progress-bar
                mode="determinate"
                value="{{ selectedAddress.load }}"
                [ngClass]="{
                  'progress-yellow': selectedAddress.load < 100,
                  'progress-green': selectedAddress.load === 100,
                  'text-gray-400': selectedAddress.load === 0,
                }"
              ></mat-progress-bar>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Actions -->
    <div
      class="mt-6 flex shrink-0 items-center justify-center space-x-3 sm:ml-auto sm:mt-0"
    >
      <!-- <mat-icon
          [matTooltip]="
            isShowGrap ? 'Ocultar estadisticas' : 'Mostrar estadisticas'
          "
          (click)="onHandleGraph()"
          svgIcon="heroicons_solid:chart-bar"
          color="primary"
        >
        </mat-icon> -->

      <!--  Button acciones Importar  -->
    </div>
    <!-- </div> -->
    <!-- </div> -->
    <div
      class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent"
    >
      <mat-tab-group
        class="flex flex-auto flex-col min-h-0 border-t"
        [(selectedIndex)]="selectedTabIndex"
      >
        <!--
    
     label="Paso 1 - Importar"
       
        class="p-0"-->
        <mat-tab [disabled]="isTabDisable.tab1">
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon
                svgIcon="heroicons_outline:arrow-down-tray"
                class="w-6 h-6 text-blue-500"
              ></mat-icon>
              <span>Importar</span>
            </div>
          </ng-template>

          <!--  style="height: calc(100vh - 340px)" -->
          <!-- Tabla screen 1.1 -->
          <div
            *ngIf="!hasAdditionalData"
            class="flex flex-col flex-auto min-h-0"
            [style]="
              isShowGrap
                ? 'height: calc(100vh - 290px)'
                : 'height: calc(100vh - 250px)'
            "
          >
            <!-- Tabla -->
            <div class="container flex flex-col flex-1 min-h-0 overflow-hidden">
              <!-- Header -->
              <div class="overflow-auto flex-1 sticky top-0 z-10">
                <table
                  mat-table
                  [dataSource]="dataSource"
                  matSort
                  (matSortChange)="onSortChange($event, 1)"
                  class="min-w-500 overflow-y-visible mat-elevation-z"
                >
                  <!-- Nombre -->
                  <ng-container matColumnDef="material">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 py-3 text-left"
                    >
                      Material
                    </th>
                    <td mat-cell *matCellDef="let data" class="py-3">
                      <span class="table-text-code"
                        >{{ data?.material?.code }} </span
                      ><br />
                      {{ data?.material?.name }}
                    </td>
                  </ng-container>

                  <!-- Unidad de medida Paralela -->
                  <ng-container matColumnDef="umd">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="px-6 text-left"
                      matTooltip="Unidad de Medida Distribucion"
                    >
                      U.M. Distribución
                    </th>
                    <td mat-cell *matCellDef="let data">
                      <!--
                        <div class="flex flex-row items-center">
                      
                  
                      <mat-checkbox
                        [(ngModel)]="data.isUMP"
                        class="custom-checkbox"
                        matTooltip="Elegir como unidad de medida a usar"
                        (change)="onChangeUMP($event, data)"
                      ></mat-checkbox>

                      {{ data?.pararellUnitOfMeasure?.code }}
                    </div>
                      -->
                      <mat-form-field
                        class="fuse-mat-dense fuse-mat-rounded w-full"
                        subscriptSizing="dynamic"
                      >
                        <mat-select
                          [(ngModel)]="data.selected"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Selecciona unidad de distribucion"
                          panelClass="umd-select-panel"
                          (openedChange)="$event && onOpenUmd(data)"
                          (ngModelChange)="onChangeActive(data)"
                        >
                          <mat-option
                            *ngFor="let opt of data.listUm"
                            [value]="opt.option"
                            [disabled]="opt.disabled"
                            [matTooltip]="opt.umdTooltip"
                            [matTooltipDisabled]="!opt.umdTooltip"
                            matTooltipPosition="left"
                          >
                            {{ opt.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <!-- Unidad de medida Base  
                 
                   <ng-container matColumnDef="umb">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    class="px-6 text-left"
                    matTooltip="Unidad de Medida Base"
                  >
                    U.M.B
                  </th>
                  <td mat-cell *matCellDef="let data">
                    <div class="flex flex-row items-center">
                      <mat-checkbox
                        class="custom-checkbox"
                        [(ngModel)]="data.isUMB"
                        matTooltip="Elegir como unidad de medida a usar"
                        (change)="onChangeUMB($event, data)"
                      ></mat-checkbox>
                      {{ data?.baseUnitOfMeasure?.code }}
                    </div>
                  </td>
                </ng-container>
                
                -->

                  <!-- Cantidad UM Base -->
                  <ng-container matColumnDef="ctnUmb">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="flex-1 text-right px-6"
                    >
                      <p class="px-6">Cnt. UMB</p>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let data"
                      class="td-margin text-right"
                    >
                      <p class="px-3">
                        {{ data?.TotalBaseQuantity | number: "1.3-3" }}
                        {{ data?.baseUnitOfMeasure?.code }}
                      </p>
                    </td>
                  </ng-container>

                  <!-- Cantidad UM Pedido -->
                  <ng-container matColumnDef="ctnUmp">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="flex-1 text-right px-6"
                    >
                      <p class="px-6">Cnt. UMP</p>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let data"
                      class="td-margin text-right"
                    >
                      <p class="px-6">
                        {{
                          data?.TotalPararellQuantity !== "-"
                            ? data?.TotalPararellQuantity +
                              " " +
                              data?.pararellUnitOfMeasure?.code
                            : "-"
                        }}
                      </p>
                    </td>
                  </ng-container>

                  <!-- Encabezado -->
                  <thead class="sticky top-0 z-10">
                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumns"
                      class="bg-white dark:bg-gray-900"
                    ></tr>
                  </thead>

                  <!-- Filas -->
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    class="border-b"
                  ></tr>
                </table>
                <div
                  *ngIf="this.dataSource?.data?.length === 0"
                  class="border-t p-8 text-center text-1xl sm:p-10"
                >
                  Lo sentimos, no hay registros para mostrar.
                </div>
              </div>
            </div>
          </div>
          <!-- Paginación -->
          <div class="order-t bg-gray-100 dark:bg-gray-900 flex-shrink-0">
            <mat-paginator
              #paginatorTable1
              *ngIf="!hasAdditionalData"
              class="z-10"
              [pageSizeOptions]="[50, 100, 150, 200]"
              showFirstLastButtons
              [length]="totalItemsTable1"
              [pageSize]="pageSizeTable1"
              (page)="onPageChangeTable1($event)"
            ></mat-paginator>
          </div>
          <!-- Tabla screen 1.2 -->
          <div
            *ngIf="hasAdditionalData"
            class="flex flex-col flex-auto min-h-0 overflow-hidden"
            [style]="
              isShowGrap
                ? 'height: calc(100vh - 210px)'
                : 'height: calc(100vh - 180px)'
            "
          >
            <!-- Tabla -->
            <div class="container flex flex-col flex-1 min-h-0 overflow-hidden">
              <!-- Header -->
              <div class="overflow-auto flex-1 sticky top-0 z-10">
                <table
                  mat-table
                  [dataSource]="dataSourceNew"
                  matSort
                  (matSortChange)="onSortChange($event, 2)"
                  class="min-w-500 overflow-y-visible mat-elevation-z"
                >
                  <!-- Nombre -->
                  <ng-container matColumnDef="material">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-left"
                    >
                      Material
                    </th>

                    <td mat-cell *matCellDef="let data" class="py-3">
                      <span class="table-text-code"
                        >{{ data?.material?.code }} </span
                      ><br />
                      {{ data?.material?.name }}
                    </td>
                  </ng-container>

                  <!-- Unidad de medida -->
                  <ng-container matColumnDef="um">
                    <th mat-header-cell *matHeaderCellDef class="text-left">
                      <p class="px-6">U.M</p>
                    </th>
                    <td mat-cell *matCellDef="let data" class="py-3">
                      {{
                        data?.selected === 1
                          ? data?.baseUnitOfMeasure?.code
                          : data?.pararellUnitOfMeasure?.code
                      }}
                    </td>
                  </ng-container>

                  <!-- Cantidad UM Base -->
                  <ng-container matColumnDef="cntRequested">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="flex-1 text-right px-6"
                    >
                      <p class="px-6">Cnt. Solicitada</p>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let data"
                      class="py-3 text-right px-6"
                    >
                      <p class="px-6">
                        {{
                          (data?.selected === 1
                            ? data?.TotalBaseQuantity
                            : data?.TotalPararellQuantity
                          ) | number: "1.3-3"
                        }}
                      </p>
                    </td>
                  </ng-container>

                  <!-- Cantidad  Cantidad Disponibl  -->
                  <ng-container matColumnDef="cntAvailable">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="flex-1 text-right px-6"
                    >
                      <p class="px-6">Cnt. Disponible</p>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let data"
                      class="py-3 text-right px-6"
                    >
                      <p class="px-6">
                        {{
                          (data?.selected === 1
                            ? data?.availableQuantity
                            : data?.availableQuantityPararell
                          ) | number: "1.3-3"
                        }}
                      </p>
                    </td>
                  </ng-container>
                  <!-- Cantidad no cubierta Pedido -->
                  <ng-container matColumnDef="cntNoCovered">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="flex-1 text-right px-6"
                    >
                      Cnt. No Cubierta
                    </th>
                    <td mat-cell *matCellDef="let data" class="py-3 text-right">
                      <p class="px-6">
                        {{ data?.cntNoCovered | number: "1.3-3" }}
                      </p>
                    </td>
                  </ng-container>

                  <!-- Encabezado -->

                  <thead class="sticky top-0 z-10">
                    <tr
                      mat-header-row
                      *matHeaderRowDef="displayedColumnsNew"
                      class="bg-gray-100 dark:bg-gray-900"
                    ></tr>
                  </thead>

                  <!-- Filas -->
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsNew"
                    class="border-b"
                  ></tr>
                </table>
              </div>
            </div>
            <div class="order-t bg-gray-100 dark:bg-gray-900 flex-shrink-0">
              <mat-paginator
                #paginatorTable2
                *ngIf="hasAdditionalData"
                class="z-10"
                [pageSizeOptions]="[50, 100, 150, 200]"
                showFirstLastButtons
                [length]="totalItemsTable2"
                [pageSize]="pageSizeTable2"
                (page)="onPageChangeTable2($event)"
              ></mat-paginator>
            </div>
          </div>
        </mat-tab>
        <mat-tab [disabled]="isTabDisable.tab2">
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon
                svgIcon="heroicons_solid:user-group"
                class="w-6 h-6 text-amber-500"
              ></mat-icon>
              <span>Distribución</span>
            </div>
          </ng-template>
          <div
            class="flex flex-col flex-auto min-h-0 overflow-hidden"
            [style]="
              isShowGrap
                ? 'height: calc(100vh - 210px)'
                : 'height: calc(100vh - 180px)'
            "
          >
            <!--
             <mat-slide-toggle
            style="margin-top: 0.7em"
            color="primary"
            class="mx-4 self-end my-3"
            [(ngModel)]="modeResume"
            (change)="handleModeView()"
          >
            Resumen
          </mat-slide-toggle>
          -->
            <!-- Tabla -->
            <div class="container flex flex-col flex-1 min-h-0 overflow-hidden">
              <!-- Header -->
              <div class="overflow-auto flex-1 sticky top-0 z-10">
                <table
                  class="min-w-500 overflow-y-visible mat-elevation-z"
                  mat-table
                  [dataSource]="dataSourceDistribution"
                  matSort
                  (matSortChange)="onSortChange($event, 3)"
                  matSortDisableClear
                  multiTemplateDataRows
                >
                  <ng-container matColumnDef="det">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td *matCellDef="let row" style="width: 5px">
                      <button
                        class="h-7 min-h-7 min-w-10 px-2 leading-6"
                        (click)="toggleDetails(row)"
                        style="margin-left: 10px"
                      >
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="
                            selectedSD?.material?.code === row?.material?.code
                              ? 'heroicons_solid:chevron-up'
                              : 'heroicons_solid:chevron-down'
                          "
                        ></mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <!-- Cliente -->
                  <ng-container matColumnDef="material">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-left"
                    >
                      Material
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="text-left text-uppercase"
                    >
                      <span class="table-text-code">{{
                        row?.material.code
                      }}</span
                      ><br />{{ row?.material.name }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="stockRequired">
                    <th mat-header-cell *matHeaderCellDef class="text-right">
                      Solicitado
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                      {{ row.stockRequest | number: "1.3-3" }}
                    </td>
                  </ng-container>

                  <!-- Stock Solicitado -->
                  <ng-container matColumnDef="stockCurrent">
                    <th mat-header-cell *matHeaderCellDef class="text-right">
                      Inventario Actual
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                      {{ row.stockCurrent | number: "1.3-3" }}
                    </td>
                  </ng-container>

                  <!--  Por Cumprir -->
                  <ng-container matColumnDef="toFulFill">
                    <th mat-header-cell *matHeaderCellDef class="text-right">
                      No Cumplido
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                      {{ row.toFulFill | number: "1.3-3" }}
                    </td>
                  </ng-container>

                  <!-- Ruta -->
                  <ng-container matColumnDef="distribution">
                    <th mat-header-cell *matHeaderCellDef class="text-right">
                      Distribución
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-right">
                      {{ row.distribution | number: "1.3-3" }}
                      {{
                        row?.selected === 1
                          ? row?.baseUnitOfMeasure?.code
                          : row?.pararellUnitOfMeasure?.code
                      }}
                    </td>
                  </ng-container>

                  <!--  % de Cumplimiento -->
                  <ng-container matColumnDef="tobefulfilled">
                    <th mat-header-cell *matHeaderCellDef class="text-right">
                      % de Cumplimiento
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      [class]="
                        row.porcentCompleted === 100
                          ? 'text-right text-green-500'
                          : row.porcentCompleted === 0
                            ? 'text-right text-red-500'
                            : 'text-right text-amber-500'
                      "
                    >
                      {{ row.porcentCompleted | number: "1.2-2" }} %
                    </td>
                  </ng-container>

                  <!-- Ubicación -->
                  <ng-container matColumnDef="distributed">
                    <th mat-header-cell *matHeaderCellDef class="text-right">
                      Distribuido
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      [class]="
                        row.porcentDistribuite === 100
                          ? 'text-right text-green-500'
                          : row.porcentDistribuite === 0
                            ? 'text-right text-red-500'
                            : 'text-right text-amber-500'
                      "
                    >
                      {{ row.porcentDistribuite ?? 0 | number: "1.2-2" }} %
                    </td>
                  </ng-container>

                  <!-- option -->
                  <ng-container matColumnDef="option">
                    <th mat-header-cell *matHeaderCellDef class="text-left">
                      <mat-checkbox
                        class="custom-checkbox"
                        [(ngModel)]="checkAllDistribution"
                        (change)="openDialogCheck($event)"
                      ></mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row" class="text-left">
                      <mat-checkbox
                        class="custom-checkbox"
                        [(ngModel)]="row.isChecked"
                        (change)="onChangeCheckboxConfirmedGeneral($event, row)"
                      ></mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td
                      mat-cell
                      *matCellDef="let row"
                      [attr.colspan]="
                        displayedColumnsDistributionGeneral.length
                      "
                    >
                      <ng-container
                        *ngIf="
                          selectedSD?.material?.code === row?.material?.code
                        "
                        class="details-row"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            rowDetailsTemplate;
                            context: { $implicit: row }
                          "
                        ></ng-container>
                      </ng-container>
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsDistributionGeneral"
                    class="sticky top-0 z-10 bg-white dark:bg-gray-900"
                  ></tr>

                  <!-- Fila Principal -->
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: displayedColumnsDistributionGeneral
                    "
                    class="border-b"
                    [class.table-expanded-row]="
                      selectedSD?.material?.code === row?.material?.code
                    "
                  ></tr>

                  <tr
                    mat-row
                    *matRowDef="let row; columns: ['expandedDetail']"
                    class="table-detail-row"
                  ></tr>
                </table>
              </div>
              <div
                *ngIf="this.dataSourceNew?.data?.length === 0"
                class="border-t p-8 text-center text-1xl sm:p-10"
              >
                Lo sentimos, no hay registros para mostrar.
              </div>
              <!--
            <hr/>
            <div class="flex flex-row">
              <p>
                <span class="table-text-code"
                      > 432423 </span
                    ><br />
                  Socio de negocio
              </p>
              

            </div>     
       
       -->
            </div>
            <div class="order-t bg-gray-100 dark:bg-gray-900 flex-shrink-0">
              <mat-paginator
                #paginatorTable2
                class="z-10"
                [pageSizeOptions]="[50, 100, 150, 200]"
                showFirstLastButtons
                [length]="totalItemsTable3"
                [pageSize]="pageSizeTable3"
                (page)="onPageChangeTable3($event)"
              ></mat-paginator>
            </div>
          </div>
        </mat-tab>

        <mat-tab [disabled]="isTabDisable.tab3">
          <ng-template mat-tab-label>
            <div class="flex flex-row items-center gap-2">
              <mat-icon
                svgIcon="heroicons_solid:truck"
                class="w-6 h-6 text-green-500"
              ></mat-icon>
              <span>Entregas</span>
            </div>
          </ng-template>
          <div
            class="flex flex-col flex-auto min-h-0 overflow-hidden"
            [style]="
              isShowGrap
                ? 'height: calc(100vh - 210px)'
                : 'height: calc(100vh - 180px)'
            "
          >
            <!-- Tabla -->
            <div class="container flex flex-col flex-1 min-h-0 overflow-hidden">
              <!-- Header -->
              <div class="overflow-auto flex-1 sticky top-0 z-10">
                <table
                  class="min-w-500 overflow-y-visible mat-elevation-z"
                  mat-table
                  [dataSource]="dataSourceDelivery"
                  matSort
                  (matSortChange)="onSortChange($event, 4)"
                  matSortDisableClear
                  multiTemplateDataRows
                >
                  <ng-container matColumnDef="det">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td *matCellDef="let row" style="width: 5px">
                      <button
                        class="leading-6"
                        (click)="toggleDetailsDelivery(row)"
                        style="margin-left: 10px"
                      >
                        <mat-icon
                          class="icon-size-5"
                          [svgIcon]="
                            selectedSDelivery?.material?.code ===
                            row?.material?.code
                              ? 'heroicons_solid:chevron-up'
                              : 'heroicons_solid:chevron-down'
                          "
                        ></mat-icon>
                      </button>
                    </td>
                  </ng-container>

                  <!-- Cliente -->
                  <ng-container matColumnDef="material">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-left"
                    >
                      Material
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row"
                      class="text-left text-uppercase"
                    >
                      <span class="table-text-code">{{
                        row?.material.code
                      }}</span
                      ><br />{{ row?.material.name }}
                    </td>
                  </ng-container>

                  <!-- Ruta -->
                  <ng-container matColumnDef="delivery">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      class="px-6 text-left"
                    >
                      Entrega
                    </th>
                    <td mat-cell *matCellDef="let row" class="px-6 text-left">
                      {{ row.delivery | number: "1.3-3" }}
                      {{
                        row?.selected === 1
                          ? row?.baseUnitOfMeasure?.code
                          : row?.pararellUnitOfMeasure?.code
                      }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="expandedDetail">
                    <td
                      mat-cell
                      *matCellDef="let row"
                      [attr.colspan]="displayedColumnsDeliveryGeneral.length"
                    >
                      <ng-container
                        *ngIf="
                          selectedSDelivery?.material?.code ===
                          row?.material?.code
                        "
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            rowDetailsTemplateDelivery;
                            context: { $implicit: row }
                          "
                        ></ng-container>
                      </ng-container>
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsDeliveryGeneral"
                    class="sticky top-0 z-10 bg-white dark:bg-gray-900"
                  ></tr>

                  <!-- Fila Principal -->
                  <tr
                    mat-row
                    *matRowDef="
                      let row;
                      columns: displayedColumnsDeliveryGeneral
                    "
                    class="border-b"
                    [class.table-expanded-row]="
                      selectedSDelivery?.material?.code === row?.material?.code
                    "
                  ></tr>

                  <tr
                    mat-row
                    *matRowDef="let row; columns: ['expandedDetail']"
                    class="table-detail-row"
                  ></tr>
                </table>
              </div>
              <div
                *ngIf="this.dataSourceDelivery?.data?.length === 0"
                class="border-t p-8 text-center text-1xl sm:p-10"
              >
                Lo sentimos, no hay registros para mostrar.
              </div>
            </div>
            <div class="order-t bg-gray-100 dark:bg-gray-900 flex-shrink-0">
              <mat-paginator
                #paginatorTable4
                class="z-10"
                [pageSizeOptions]="[50, 100, 150, 200]"
                showFirstLastButtons
                [length]="totalItemsTable4"
                [pageSize]="pageSizeTable4"
                (page)="onPageChangeTable4($event)"
              ></mat-paginator>
            </div>
          </div>
          <ng-template #rowDetailsTemplateDelivery let-business>
            <div class="overflow-hidden">
              <div class="flex">
                <table
                  mat-table
                  [dataSource]="dataSourceItemsDelivery"
                  matSort
                  #sortMultiTable1="matSort"
                  class="min-w-500 overflow-y-visible mat-elevation-z mt-3"
                >
                  <!-- Columnas de la tabla expandida -->
                  <!-- Columna  Socio de negocions  -->
                  <ng-container matColumnDef="businessParther">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="px-6 text-left"
                    >
                      Socio de Negocio
                    </th>
                    <td mat-cell *matCellDef="let subData" class="py-3">
                      <span class="table-text-code"
                        >{{ subData?.shipTo?.externalKeys?.code }} </span
                      ><br />
                      {{ subData?.shipTo?.name }}
                    </td>
                  </ng-container>

                  <!-- Columna Precio -->
                  <ng-container matColumnDef="price">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-right"
                    >
                      Precio
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let subData"
                      class="py-3 text-right"
                    >
                      {{ subData?.unitPrice | decimalFormat }}
                    </td>
                  </ng-container>

                  <!-- Columna Cantidad Solicitada -->
                  <ng-container matColumnDef="ctnRequired">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="flex-1 text-right"
                    >
                      Cantidad Solicitada
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let subData"
                      class="text-right td-margin"
                    >
                      {{ subData?.baseQuantity | number: "1.3-3" }}
                    </td>
                  </ng-container>

                  <!-- Columna Cantidad Propuesta -->
                  <ng-container matColumnDef="confirmed" class="h-full">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="text-right"
                    >
                      Cantidad Atendida
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let subData"
                      class="td-margin text-right"
                    >
                      {{ subData.soldQuantitySuggested ?? 0 | number: "1.3-3" }}
                    </td>
                  </ng-container>

                  <!-- Encabezado -->
                  <tr
                    mat-header-row
                    *matHeaderRowDef="displayedColumnsDelivery"
                    class="sticky top-0 z-10 bg-white dark:bg-gray-900"
                  ></tr>

                  <!-- Fila de datos -->
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumnsDelivery"
                    class="border-b"
                  ></tr>
                </table>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <!-- Filter -->
  <app-filter
    (onFilterEvent)="handleFilterSearch()"
    (onCleanEvent)="handleFilterClean()"
  >
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showUploadDate]="true" />
    </app-filter-section>

    <app-filter-section
      title="Configuración"
      [expanded]="false"
      (onExpanded)="onConfigExpanded()"
    >
      <app-configuration-filters
        [form]="form"
        [companyWithMongoId]="true"
        [officeGroupByMongoId]="true"
        [salesOfficeWithMongoId]="true"
        (selectionChangeCompany)="onSelectionTerritory()"
        (selectionChangeSalesGroup)="onSelectionChangeSalesGroup()"
        [loadData]="loadConfigData"
      ></app-configuration-filters>
    </app-filter-section>

    <app-filter-section
      title="Documentos"
      [expanded]="false"
      (onExpanded)="onDocumentsExpanded()"
    >
      <app-documents-filters
        [form]="form"
        [documentClassWhitMongoId]="true"
        [typeDocumentClass]="'DT002'"
        [loadData]="loadDocumentsData"
      ></app-documents-filters>
    </app-filter-section>

    <app-filter-section
      title="Gestión de Rutas"
      [expanded]="false"
      (onExpanded)="onRoutesExpanded()"
    >
      <app-routes-filters
        [form]="form"
        [territoryWithMongoId]="true"
        [areaRouteWithMongoId]="true"
        [routeGroupWithMongoId]="true"
        [routeWithMongoId]="true"
        [loadData]="loadRoutesData"
      ></app-routes-filters>
    </app-filter-section>
    <app-filter-section
      title="Gestión de Materiales"
      [expanded]="false"
      (onExpanded)="onMaterialsExpanded()"
    >
      <app-materials-management-filters
        [form]="form"
        [materialGroupWithMongoId]="true"
        [materialWithMongoId]="true"
        [isMultiple]="true"
        [loadData]="loadMaterialsData"
      />
    </app-filter-section>

    <app-filter-section
      title="Socio de negocios"
      [expanded]="false"
      (onExpanded)="onBusinessPartnersExpanded()"
    >
      <app-business-partners-filters
        [form]="form"
        [businessPartnerWithMongoId]="true"
        [loadData]="loadBusinessPartnersData"
      ></app-business-partners-filters>
    </app-filter-section>
  </app-filter>
</mat-sidenav-container>

<ng-template #rowDetailsTemplate let-distribution>
  <div class="overflow-hidden">
    <ng-container *ngIf="searchItemDistribution">
      <mat-form-field
        class="fuse-mat-dense fuse-mat-rounded min-w-64 mx-3 w-80 my-1 mt-2"
        subscriptSizing="dynamic"
      >
        <mat-icon
          class="icon-size-5"
          matPrefix
          svgIcon="heroicons_solid:magnifying-glass"
        ></mat-icon>
        <input
          matInput
          placeholder="Buscar"
          autocomplete="off"
          (input)="onHandleSearchDistibution($event)"
        />
      </mat-form-field>
    </ng-container>
    <div class="flex">
      <table
        mat-table
        [dataSource]="dataSourceItemsDistribution"
        matSort
        #sortMultiTable1="matSort"
        class="min-w-500 overflow-y-visible mat-elevation-z mt-3"
      >
        <!-- Columnas de la tabla expandida -->
        <!-- Columna  Socio de negocions  -->
        <ng-container matColumnDef="businessParther">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="px-6 text-left"
          >
            <mat-icon
              class="pr-2 cursor-pointer"
              svgIcon="heroicons_solid:magnifying-glass"
              (click)="searchDistributionActive()"
            ></mat-icon>
            Socio de Negocio
          </th>
          <td mat-cell *matCellDef="let subData" class="py-3">
            <span class="table-text-code"
              >{{ subData?.shipTo?.externalKeys?.code }} </span
            ><br />
            {{ subData?.shipTo?.name }}
          </td>
        </ng-container>

        <!-- Columna Precio -->
        <ng-container matColumnDef="price">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="flex-1 text-right px-6"
          >
            Precio
          </th>
          <td mat-cell *matCellDef="let subData" class="px-6 py-3 text-right">
            <p class="px-6">
              {{ subData?.unitPrice | decimalFormat }}
            </p>
          </td>
        </ng-container>

        <!-- Columna Cantidad Solicitada -->
        <ng-container matColumnDef="ctnRequired">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="flex-1 text-right px-6"
          >
            Cantidad Solicitada
          </th>
          <td mat-cell *matCellDef="let subData" class="py-3 text-right">
            <p class="px-6">
              {{ subData.baseQuantity | number: "1.3-3" }}
            </p>
          </td>
        </ng-container>

        <!-- Columna Cantidad Propuesta -->
        <ng-container matColumnDef="ctnProposed">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="flex-1 text-right px-6"
          >
            Cantidad Propuesta
          </th>
          <td mat-cell *matCellDef="let subData" class="py-3 text-right">
            <p class="px-6">
              {{ subData?.soldQuantitySuggested | number: "1.3-3" }}
            </p>
          </td>
        </ng-container>

        <!-- Columna Confirmado -->
        <ng-container matColumnDef="confirmed" class="h-full">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="pl-10">
            Confirmado
          </th>
          <td mat-cell *matCellDef="let subData">
            <div class="flex justify-center items-center gap-2 h-full">
              <input
                matInput
                type="number"
                step="0.001"
                min="0"
                [max]="subData?.soldQuantitySuggested"
                placeholder="0"
                (input)="validateInput($event, subData)"
                [(ngModel)]="subData.confirmed"
                class="w-30 text-left border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500r"
              />
              <mat-checkbox
                [(ngModel)]="subData.isChecked"
                class="custom-checkbox"
                (change)="onChangeCheckboxConfirmedItem($event, subData)"
              ></mat-checkbox>
            </div>
          </td>
        </ng-container>

        <!--  % de Cumplimiento -->
        <ng-container matColumnDef="toFulFill">
          <th mat-header-cell *matHeaderCellDef class="text-right">
            <p class="px-6">% de Cumplimiento</p>
          </th>
          <td mat-cell *matCellDef="let subData" class="text-left">
            <p
              [class]="
                subData.porcentCompleted === 100
                  ? 'px-6 text-green-500 text-right'
                  : subData.porcentCompleted === 0
                    ? 'px-6 text-red-500 text-right'
                    : 'px-6 text-amber-500 text-right'
              "
            >
              {{ subData?.porcentCompleted | number: "1.2-2" }} %
            </p>
          </td>
        </ng-container>

        <!-- Encabezado -->
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumnsDistribution"
          class="sticky top-0 z-10 bg-white dark:bg-gray-900"
        ></tr>

        <!-- Fila de datos -->
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsDistribution"
          class="border-b"
        ></tr>
      </table>
    </div>
  </div>
</ng-template>

<!-- Modal Alerta -->

<ng-template #alertDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px"
        >warning_amber</mat-icon
      >
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end gap-2">
    <a
      [routerLink]="['/assistant/delivery/loads']"
      target="_blank"
      [queryParams]="goToAssistantDeliveryQueryParams"
      mat-raised-button
      color="accent"
    >
      Ir a Asistente de Carga
    </a>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Ok
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- Confirmar modificaciones -->

<ng-template #updateDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px"
        >warning_amber</mat-icon
      >
    </div>
    <div class="grid w-full">
      <h2 mat-dialog-title class="text-lg font-bold mb-2">{{ data.title }}</h2>

      <mat-dialog-content class="modal-content mt-0">
        <p *ngIf="!data.unconfirmedItems || data.unconfirmedItems.length === 0">
          ✅ Todos los ítems están marcados. ¿Está seguro de guardar la
          distribución?
        </p>

        <div *ngIf="data.unconfirmedItems && data.unconfirmedItems.length > 0">
          <p class="mb-2">⚠️ Algunas órdenes no están marcadas:</p>
          <mat-accordion class="modern-accordion">
            <mat-expansion-panel
              *ngFor="let mat of data.unconfirmedItems"
              class="rounded-lg border border-gray-200 shadow-sm mb-2"
            >
              <mat-expansion-panel-header class="bg-white rounded-t-lg">
                <mat-panel-title class="text-gray-800 font-semibold">
                  {{ mat.materialName }} ({{ mat.orders.length }} orden(es) sin
                  confirmar)
                </mat-panel-title>
              </mat-expansion-panel-header>

              <ul class="list-disc pl-6 py-2">
                <li *ngFor="let order of mat.orders" class="text-gray-700">
                  {{ order.shipTo?.name || "Sin shipTo" }}
                </li>
              </ul>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-dialog-content>
    </div>
  </div>

  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button class="mr-3" [mat-dialog-close]="false">No</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Sí
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- Mensaje de confirmacion -->
<ng-template #corfimDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-green-500 ml-4 mt-6" style="font-size: 32px"
        >check</mat-icon
      >
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        Registros actualizados correctamente
      </h2>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-raised-button mat-dialog-close color="primary">Cerrar</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #infoCard let-data>
  <h2 mat-dialog-title class="text-lg font-bold mb-3">{{ data.title }}</h2>
  <div class="flex flex-auto flex-col" style="margin-left: 2rem">
    <ng-container>
      <mat-form-field
        class="fuse-mat-dense fuse-mat-rounded min-w-64 w-80 my-1 mb-3"
        subscriptSizing="dynamic"
      >
        <mat-icon
          class="icon-size-5"
          matPrefix
          svgIcon="heroicons_solid:magnifying-glass"
        ></mat-icon>
        <input
          matInput
          placeholder="Buscar"
          autocomplete="off"
          (input)="onSearchInput($event)"
        />
      </mat-form-field>
    </ng-container>
  </div>
  <mat-dialog-content>
    <ng-container *ngIf="data.option === 0 || data.option === 1">
      <app-table-no-select
        #tableNoSelectComponent
        [summaryData]="data.list"
        (searchChange)="onSearchInput($event)"
        [UMPActive]="UMPActive"
        [isAllColumns]="true"
        [isSearch]="true"
        [servicesFuntion]="servicesFuntion"
        [directionSort]="sortTables"
      ></app-table-no-select>
    </ng-container>
    <ng-container *ngIf="data.option === 2">
      <app-table-list-client
        #tableListClientComponent
        [summaryData]="data.list"
        (searchChange)="onSearchInput($event)"
        [servicesFuntion]="servicesFuntion"
      >
      </app-table-list-client>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions class="modal-actions flex flex-col justify-end">
    <div class="w-full flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
      <mat-paginator
        class="z-10"
        #paginationCards
        [pageSizeOptions]="[50, 100, 150, 200]"
        showFirstLastButtons
        [length]="totalItemsCard"
        [pageSize]="pageSizeCard"
        (page)="onPageChangeCardsInfo($event)"
      ></mat-paginator>
    </div>
    <button mat-raised-button mat-dialog-close class="self-end" color="primary">
      Cerrar
    </button>
  </mat-dialog-actions>
</ng-template>

<!-- Mesansaje de confimacion -->

<ng-template #excludeDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon
        class="text-green-500 ml-4 mt-6"
        style="font-size: 36px"
        svgIcon="heroicons_outline:question-mark-circle"
      ></mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button
      mat-button
      mat-dialog-close
      class="align-left mr-3"
      [mat-dialog-close]="false"
    >
      No
    </button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Si
    </button>
  </mat-dialog-actions>
</ng-template>

<!--Mensaje de reinicio-->
<ng-template #restartDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px">warning_amber</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end gap-2">
    <button mat-button class="mr-3" [mat-dialog-close]="false">No</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Sí
    </button>
  </mat-dialog-actions>
</ng-template>

<!--Mensaje de check al aceptar o rechazar toda la distribucion-->
<ng-template #checkDialog let-data>
  <div class="flex items-start space-x-2 m-4">
    <div class="flex items-center">
      <mat-icon class="text-amber-500 ml-4 mt-6" style="font-size: 32px">warning_amber</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">
        {{ data.title }}
      </h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>{{ data.description }}</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end gap-2">
    <button mat-button class="mr-3" [mat-dialog-close]="false">No</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
      Sí
    </button>
  </mat-dialog-actions>
</ng-template>


